module.exports = __webpack_public_path__ + "img/nlic_gallery4.9b0c3fdf.jpg";